import { Button } from "@/components/flexkit/Button";
import { Card } from "@/components/flexkit/Card";
import { Text } from "@/components/podkit/typography/Text";
import { useToast } from "@/components/podkit/toasts/use-toast";
import { useGetStripePortalUrl } from "@/queries/organization-queries";
import { formatError } from "@/utils/errors";
import type { FC } from "react";

export const StripePortalCard: FC = () => {
    const { mutate: getStripePortalUrl, isPending } = useGetStripePortalUrl();
    const { toast } = useToast();

    const handleOpenStripePortal = () => {
        getStripePortalUrl(undefined, {
            onSuccess: (data) => {
                if (data.portalUrl) {
                    window.open(data.portalUrl, "_blank");
                }
            },
            onError: (error) => {
                toast({
                    title: "Failed to open billing portal",
                    description: formatError(error),
                });
            },
        });
    };

    return (
        <Card className="flex flex-col gap-6 bg-surface-glass p-6" variant="bordered">
            <div>
                <h2 className="text-lg font-semibold text-content-primary">Billing </h2>
                <Text className="text-sm text-content-secondary">
                    Manage billing through Stripe. View payment history, download invoices, update payment methods, and
                    modify VAT information.
                </Text>
            </div>

            <div className="flex items-center justify-between">
                <Button
                    variant="primary"
                    onClick={handleOpenStripePortal}
                    disabled={isPending}
                    data-tracking-id="access-stripe-portal-stripe-portal-card"
                >
                    <span>{isPending ? "Loading..." : "Access Stripe Portal"}</span>
                </Button>
            </div>
        </Card>
    );
};
